import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { DEFAULT_LIMIT_PAGINATION } from "constants/appConstants";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import { getUsuarioById } from "services/usuarios";
import { AppDispatch, RootState } from "store/store";
import "./home.css";
import { MetricaTextCard } from "./components/MetricaTextCard/MetricaTextCard";
import { MetricaSelectCard } from "./components/MetricaSelectCard/MetricaSelectCard";
import {
  getAlcances,
  getInformacionGeneral,
  InformacionGeneralHomeI,
} from "services/general";
import { getNiveles } from "services/niveles";
import { NivelI } from "interfaces/Nivel";
import {
  getPlanesEstudioCount,
  getPlanesEstudioCountValidados,
  getPlanesEstudioValidezPorVencer,
} from "services/planesEstudio";
import { getNormativasNoAsociadasCantidad } from "services/normativas";
import { getDiseñoCurricularCount } from "services/diseñoCurricular";
import { AlcanceI } from "interfaces/Alcance";

const Home = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [informacionGeneral, setInformacionGeneral] = useState<
    InformacionGeneralHomeI | undefined
  >();
  const [niveles, setNiveles] = useState<NivelI[]>([]);
  const [alcances, setAlcances] = useState<AlcanceI[]>([]);
  const [planesEstudioCount, setPlanesEstudioCount] = useState<
    number | string | null
  >(null);
  const [planesEstudioVencidos, setPlanesEstudioVencidos] = useState<
    number | string | null
  >(null);
  const [planesEstudioCountValidados, setPlanesEstudioCountValidados] =
    useState<number | string | null>(null);
  const [normativasNoAsociadasCount, setNormativasNoAsociadasCount] = useState<
    number | string | null
  >(null);
  const [diseñosCurricularesCount, setdiseñosCurricularesCount] = useState<
    number | string | null
  >(null);

  const [disenioCurricularCountFilter, setDisenioCurricularCountFilter] =
    useState<number | null>(null);
  const [planesEstudioCountFilter, setPlanesEstudioCountFilter] = useState<
    number | null
  >(null);

  const initialValues: { [key: string]: string } = {
    nivel_id: "",
    alcance_id: "",
  };

  const searchDiseñosCurricularesCountByParams = async (params: {
    [key: string]: string;
  }) => {
    try {
      const filters = {
        nivel_id: params.nivel_id,
        limit: 10,
        page: 1,
      };
      const response = await getDiseñoCurricularCount(filters);
      setDisenioCurricularCountFilter(response);
    } catch (err) {
      showErrorToast("No fue posible cargar los diseños curriculares");
    } finally {
      setIsLoading(false);
    }
  };

  const searchPlanDeEstudiosCountByParams = async (params: {
    [key: string]: string;
  }) => {
    try {
      const filters = {
        alcance_id: params.alcance_id,
        limit: 10,
        page: 1,
      };
      const response = await getPlanesEstudioCount(filters);
      setPlanesEstudioCountFilter(response);
    } catch (err) {
      showErrorToast("No fue posible cargar los diseños curriculares");
    } finally {
      setIsLoading(false);
    }
  };

  const auth: any = useSelector((state: RootState) => state.authData);

  const fetchPlanesEstudioCount = async () => {
    try {
      const count = await getPlanesEstudioCount({});
      setPlanesEstudioCount(count);
    } catch (error) {
      console.error(
        "Error al obtener la cantidad de planes de estudio:",
        error,
      );
    }
  };

  const fetchPlanesEstudioCountValidados = async () => {
    try {
      const count = await getPlanesEstudioCountValidados();
      setPlanesEstudioCountValidados(count);
    } catch (error) {
      console.error(
        "Error al obtener la cantidad de planes de estudio validados a nivel nacionals:",
        error,
      );
    }
  };

  const fetchPlanesEstudioValidezVencida = async () => {
    try {
      const count = await getPlanesEstudioValidezPorVencer();
      setPlanesEstudioVencidos(count);
    } catch (error) {
      console.error(
        "Error al obtener la cantidad de planes de estudio por vencer:",
        error,
      );
    }
  };

  const fetchNormativasNoAsociadasCount = async () => {
    try {
      const count = await getNormativasNoAsociadasCantidad();
      setNormativasNoAsociadasCount(count);
    } catch (error) {
      console.error(
        "Error al obtener la cantidad de normativas no asociadas:",
        error,
      );
    }
  };

  const fetchDiseñosCurricularesCount = async () => {
    try {
      const count = await getDiseñoCurricularCount({});
      setdiseñosCurricularesCount(count);
    } catch (error) {
      console.error(
        "Error al obtener la cantidad de diseños curriculares:",
        error,
      );
    }
  };

  const { values, handleChange, resetForm } = useFormik({
    initialValues,
    onSubmit: () => {},
  });

  const loadScreen = async () => {
    try {
      const info = await getInformacionGeneral({});
      setInformacionGeneral(info);
    } catch (err: any) {}
  };

  useEffect(() => {
    const fetchNiveles = async () => {
      try {
        const response = await getNiveles({});
        setNiveles(response.elementos);
      } catch (error) {
        console.error("Error al obtener los niveles:", error);
      }
    };

    fetchNiveles();
  }, []);

  useEffect(() => {
    const fetchAlcances = async () => {
      try {
        const response = await getAlcances({});
        setAlcances(response);
      } catch (error) {
        console.error("Error al obtener los alcances:", error);
      }
    };

    fetchAlcances();
  }, []);

  useEffect(() => {
    loadScreen();
    fetchPlanesEstudioCountValidados();
    fetchNormativasNoAsociadasCount();
    fetchPlanesEstudioValidezVencida();
    fetchPlanesEstudioCount();
    fetchDiseñosCurricularesCount();
    console.log("normativasNoAsociadasCount", normativasNoAsociadasCount);
  }, []);

  useEffect(() => {
    searchDiseñosCurricularesCountByParams(values);
  }, [values.nivel_id]);

  useEffect(() => {
    searchPlanDeEstudiosCountByParams(values);
  }, [values.alcance_id]);

  const handleChangeWithResetPage = (e: any) => {
    handleChange(e);
  };

  return (
    <section>
      <h1 className="section-title">¡Hola, {auth.name}!</h1>
      <h2 className="section-subtitle mt-2 mb-4" style={{ maxWidth: "520px" }}>
        Visualizá el estado de las resoluciones, los planes de estudio y el
        diseño curricular registrados en la plataforma.
      </h2>

      <h3 className="my-3">Información general</h3>

      <div className="metricas-text-container mb-4">
        <Col>
          <MetricaTextCard
            text={informacionGeneral?.normativas.registradas}
            title={
              <>
                Normativas <br /> registradas
              </>
            }
          />
        </Col>
        <Col>
          <MetricaTextCard
            text={informacionGeneral?.diseños_curriculares.registrados}
            title={
              <>
                DC <br /> registrados
              </>
            }
          />
        </Col>
        <Col>
          <MetricaTextCard
            text={informacionGeneral?.planes_estudio.registrados}
            title={
              <>
                Planes <br /> registrados
              </>
            }
          />
        </Col>
        <Col>
          <MetricaTextCard
            text={informacionGeneral?.usuarios.registrados}
            title={
              <>
                Usuarios <br /> registrados
              </>
            }
          />
        </Col>
        <Col>
          <MetricaTextCard
            text={planesEstudioVencidos ?? "-"}
            title={
              <>
                Planes por <br /> vencer
              </>
            }
            variant="warning"
          />
        </Col>
        <Col>
          <MetricaTextCard
            text={normativasNoAsociadasCount}
            title={
              <>
                Normativas <br /> desvinculadas
              </>
            }
            variant="danger"
          />
        </Col>
      </div>

      <h3 className="my-3">Diseño curricular</h3>

      <div className="metricas-select-container mb-4">
        <MetricaSelectCard
          title="Nivel"
          opcionesSelect={niveles}
          values={values}
          id={"nivel_id"}
          arrDetalle={[
            {
              cantidad: disenioCurricularCountFilter ?? "-",
              title: "Cantidad",
            },
            //{ cantidad: 99, title: "Cantidad" },
          ]}
          handleChangeSelect={handleChangeWithResetPage}
        />
      </div>

      <h3 className="my-3">Planes de estudio</h3>

      <div className="metricas-select-container mb-4">
        <MetricaSelectCard
          title="Alcances"
          opcionesSelect={alcances}
          values={values}
          id={"alcance_id"}
          arrDetalle={[
            { cantidad: planesEstudioCountFilter ?? "-", title: "Cantidad" },
            // {
            //   cantidad: planesEstudioCountValidados ?? "-",
            //   title: "Validados a nivel nacional",
            // },
          ]}
          handleChangeSelect={handleChangeWithResetPage}
        />
      </div>
    </section>
  );
};

export default Home;
